import { render, staticRenderFns } from "./InfoRemarks.vue?vue&type=template&id=cadebc18&scoped=true&"
import script from "./InfoRemarks.vue?vue&type=script&lang=js&"
export * from "./InfoRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadebc18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cadebc18')) {
      api.createRecord('cadebc18', component.options)
    } else {
      api.reload('cadebc18', component.options)
    }
    module.hot.accept("./InfoRemarks.vue?vue&type=template&id=cadebc18&scoped=true&", function () {
      api.rerender('cadebc18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoRemarks.vue"
export default component.exports